export default __webpack_public_path__ + "static/blueBg-c973954634ae4612ef0433eb6bbce2cf.png";